module.exports = __webpack_public_path__ + "assets/e6f7534cb048a172a21e8b7e06b8e721.png";